<template>
<div>
    <v-btn color="primary" block dark @click="dialog = !dialog">Lấy data thanh toán</v-btn>
    <v-dialog
        v-model="dialog"
        max-width="90%"
    >
        <app-card>
            <h1>Chợ Tốt</h1>
            <v-container fluid>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md4>
                        <v-text-field
                            class="mx-3"
                            v-model="token"
                            prepend-icon="code"
                            label="Chợ tốt token"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-text-field
                            class="mx-3"
                            v-model.number="limit"
                            prepend-icon="code"
                            label="Limit"
                        ></v-text-field>
                    </v-flex>
                    <v-flex
                        xs12 md4>
                        <v-btn class="mx-3" color="green" dark :loading="loading" @click="getData">Get data</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
            <app-card>
                <v-btn color="primary" @click="exportCSV">exportCSV</v-btn>
                <v-data-table
                    :rows-per-page-items="rowPerPage"
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    disable-initial-sort
                    class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.transaction_date }}</td>
                        <td class="text-xs-left">{{ props.item.list_service_type }}</td>
                        <td class="text-xs-left">{{ props.item.topup_value | formatNumber }}</td>
                        <td class="text-xs-left">{{ props.item.order_value | formatNumber }}</td>
                    </template>
                </v-data-table>
            </app-card>
        </app-card>
    </v-dialog>
</div>
</template>
<script>

import api from '../../api'
import XLSX from 'xlsx'
export default {
    name: "chotot-component",
    data(){
        return {
            dialog: false,
            token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1ODgzOTM1NzYsImlzcyI6ImNob3RvdCIsInN1YiI6IjEwNzQ1NTE5In0.8zpRAxPqvISvki8GZW7p3hRP3gQOcpBSChoChc2FfRE',
            items: [],
            limit: 100,
            loading: false,
            headers: [
                { text: 'Ngày', value: "transaction_date"},
                { text: 'Type', value: "list_service_type"},
                { text: 'order_value', value: "topup_value"},
                { text: 'order_title', value: "order_value"},
            ],
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            transaction_data: []
        }
    },
    methods: {
        async getData(){
            this.error = false
            this.loading = true
            const limit = this.limit;
            let count = 0;
            const promises = [];
            this.items = []
            this.transaction_data = []

            while (count < limit) {
                const postData = {
                    token: this.token,
                    limit: count + 20 > limit ? limit : count + 20,
                    offset: count,
                }
                promises.push(api.getChoTotTransaction(postData))
                count += 20
            }
            const data_array = await Promise.all(promises);
            this.loading = false
            const transaction_data = []
            if (data_array.some(res => res.data.status != 200))
                return swal.fire('Lỗi', 'Token hết hạn', 'error');
            data_array.forEach(res =>{
                if (res.status === 200)
                    if (res.data.status == 200)
                        transaction_data.push(...res.data.data)
                else this.error = true
            })
            this.transaction_data = transaction_data
            this.items = this.handleTransactionData(transaction_data)
        },
        handleTransactionData: function (transaction_data){
            const results = [];
            const min_date = transaction_data[transaction_data.length -1].paid_date.substr(0, 10);
            const max_date = transaction_data[0].paid_date.substr(0, 10);
            let temp = new Date(min_date);
            while (temp <= new Date(max_date)){
                results.push({
                    transaction_date: temp.toISOString().substr(0, 10),
                    list_transactions: [],
                    list_service_type: "",
                    order_title: "",
                    order_value: 0,
                    topup_value: 0


                })
                temp.setDate(temp.getDate() + 1)
            }
            transaction_data.forEach(trans => {
                const transaction_date = trans.paid_date.substr(0, 10);
                const found_date_in_result = results.find(data => data.transaction_date == transaction_date )
                found_date_in_result.list_transactions.push(trans)
                found_date_in_result.list_service_type += (found_date_in_result.order_title ? "," : "") + trans.list_service_type
                found_date_in_result.order_title += (found_date_in_result.order_title ? "," : "") + trans.order_title
                found_date_in_result.order_value += trans.order_type != "topup" ? Number(trans.order_value): 0
                found_date_in_result.topup_value += trans.order_type == "topup" ? Number(trans.order_value): 0
            });

            results.forEach(trans => {
                const list_service_type = trans.list_service_type.split(",")
                let count = list_service_type.filter(item => item === "bump").length
                if (count > 0) {
                    trans.list_service_type = trans.list_service_type.replace("bump", `đẩy tin ${count} lần`)
                    trans.list_service_type = trans.list_service_type.replace(/bump,/g, '')
                    trans.list_service_type = trans.list_service_type.replace(/,bump/g, '')
                }
                trans.list_service_type = trans.list_service_type.replace(/ad_feature/g, 'tin HOT')
                trans.list_service_type = trans.list_service_type.replace(/timer_bump/g, 'hẹn giờ đẩy')
                trans.list_service_type = trans.list_service_type.replace(/topup/g, 'nạp tiền')
                trans.list_service_type = trans.list_service_type.replace(/sticky_ad/g, 'tin ưu tiên')
            })
            
            return results
        },
        exportCSV: function (){
            const rows = this.items.map(e => {
                return {
                    transaction_date: e.transaction_date,
                    list_service_type: e.list_service_type,
                    topup_value: e.topup_value,
                    order_value: e.order_value,
                    order_title: e.order_title
                }
            })
            const wb = XLSX.utils.book_new()
            const ws = XLSX.utils.json_to_sheet(rows)
            const month = new Date().toISOString().substr(0, 10);
            XLSX.utils.book_append_sheet(wb, ws, month)
            XLSX.writeFile(wb, 'chotot-' + month + '.csv')
        }
    }
}
</script>